import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import type { Accent } from '@omni/ai/features/card.schema';
import { NovaMarkdownPipe } from '../../nova-markdown.pipe';

/**
 * Renders the two prose section types:
 *  - `text`    — markdown body via {@link NovaMarkdownPipe} (sanitized `[innerHTML]`,
 *                NO `bypassSecurityTrust`).
 *  - `callout` — a single-phrase pull-quote banner; the accent maps to a
 *                design-token color set (`info|success|warning|risk`).
 *
 * One leaf serves both types; the template switches on the presence of
 * `accent`/`callout` content.
 */
@Component({
  selector: 'card-text',
  standalone: true,
  imports: [CommonModule, IonicModule, NovaMarkdownPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './card-text.component.html',
  styleUrls: ['./card-text.component.scss'],
})
export class CardTextComponent {
  /** Markdown prose for a `text` section; null for a `callout` section. */
  @Input() text: string | null = null;

  /** When set, render the callout banner variant instead of prose. */
  @Input() callout: string | null = null;

  /** Accent for the callout banner; falls back to `info`. */
  @Input() accent: Accent | null = null;

  get calloutClass(): string {
    return 'card-callout--' + (this.accent ?? 'info');
  }
}
